<div
  #sliderRef
  resizeObserver
  class="slider"
  [class.hide]="!activeLabel()"
  pan
  (pan)="handleMove($event, false)"
  (panEnd)="handleMove($event, true)"
  (tap)="handleMove($event)"
  (resize)="handleResize($event)"
>
  <div class="bg" [ngStyle]="{ background: style().color }"></div>
  <div class="fill" [style.width.px]="fillWidth()"></div>

  <div #mainPointer class="pointer cursor-pointer" [style.left.px]="mainPointerLeft()" [style.background]="style().color" tabindex="0"></div>
  <div #movePointer class="move-pointer cursor-pointer" [style.left.px]="movePointerLeft()"></div>
</div>

<div #label class="label" [style.width.px]="labelWidth()">
  {{ activeLabel() }}
</div>
